import { useTranslation } from 'react-i18next';
import React from 'react';
import { EditUnderlinedIcon } from './buttons/IconButtons';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @Description: Rounded image component with an upload file icon.
 * @param Image preview: Image source for visualization (required).
 * @param event click: click event (optional).
 * @param String className: Style class for container image or default style class declared (optional).
 * @param String classNameWH: Style to define the size of the image and its container (optional).
 * @returns {JSX.Element}
 */
const ImagePreview = ({ preview, click, className = '', classNameWH = 'w-160px-h-160px' }) => {
    const { t } = useTranslation();

    return (
        <div className={`d-flex align-items-center ${className}`}>
            <div className={`image-profile ${classNameWH}`}>
                <img className={classNameWH} src={preview} alt='add' />
                {click &&
                    <div className='upload-profile-icon-btn'
                        onClick={() => {
                            click();
                        }}
                    >
                       <EditUnderlinedIcon className='icon-color-general-00'/>
                    </div>
                }
            </div>
        </div>
    );
};

export default ImagePreview;
